<template>
    <div>
    <div class="popup__header">
        <div class="title">Ошибка</div>
    </div>


    <div class="popup__content">
        <div class="mb40 mt40 df">

            <div class="text-color-red">
                Внимание! Возникла проблема с web-socket, <br>
                перезагрузите страницу или обратитесь в IT отдел.
            </div>
        </div>

    </div>
</div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import TextareaField from '@/components/forms/TextareaField.vue';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import {mapState} from "vuex";

    export default {
        name: "ErrorSocket",
        components: {
            Tooltip,
            SubmitBtn,
            TextareaField,
            InputSelect,
        },
        props: {

        },
        watch: {

        },
        data: function () {
            return {

            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,

            }),

        },
        mounted: function () {

        },

        methods: {

        },
    }
</script>

<style scoped>
</style>
